import { useState, useEffect } from "react";
import { Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import GaugeChart from "react-gauge-chart";

import { getByDotNotation } from "./utils.js";

const useStyles = makeStyles((theme) => ({
	root: {
		width: "100%",
		height: "100%",
		background: "white",
		color: theme.palette.primary.main,
		padding: "1%",
		display: "flex",
		flexDirection: "column",
		justifyContent: "center",
		alignItems: "center",
	},
}));

const Gauge = ({
	// itemWidth,
	// itemHeight,
	variables,
	// calculateFontSize,
	mode,
	liveVariables = {},
}) => {
	const classes = useStyles();
	const [value, setValue] = useState(0);

	useEffect(() => {
		const minValue = variables.minValue?.value || 0;
		const maxValue = variables.maxValue?.value || 100;

		let liveValue;
		if (mode === "edit") {
			liveValue = Math.random() * (maxValue - minValue) + minValue;
		} else {
			liveValue = getByDotNotation(liveVariables, variables?.variable?.value);
			if (!liveValue) {
				liveValue = liveVariables[variables?.variable?.value];
			}
		}

		const percentage = ((liveValue || 0) - minValue) / (maxValue - minValue);
		setValue(Math.max(0, Math.min(100, percentage * 100)));
	}, [liveVariables, mode, variables]);

	return (
		<Grid
			item
			className={classes.root}
		>
			<GaugeChart
				nrOfLevels={variables.levels?.value || 20}
				percent={value / 100}
				textColor="#16335B"
				colors={[variables.leftColor?.value || "#DE162F", variables.rightColor?.value || "#7ABF43"]}
				style={{ width: "100%" }}
				hideText={variables.hideText?.value || false}
				formatTextValue={(fValue) => `${fValue.toFixed(variables?.decimal?.value || 1)}${variables.unit?.value || "%"}`}
			/>
		</Grid>
	);
};

export default Gauge;
